/**
 * Тексты окон поверх боя (C4) на EN, RU и UK. Свои тексты каждое окно держит в `<окно>/messages.ts`, сюда они
 * собираются сами; здесь только общие: названия героев (`HeroDef.name`, `hero.<id>.description` — роль), покупки.
 * Названия усилений — `boost-choice/messages.ts`. Подключаются `addMessages(windowMessages)` в `registerWindows()`.
 */
import type { MessageBundle } from "../../i18n";

const en = {
  "win.pay.telegram": "Open in Telegram",
  "win.pay.telegramNote": "Rematch, skip and VIP are available in Telegram",
  "hero.gunner.name": "Gunner",
  "hero.gunner.description": "Steady damage to one target",
  "hero.bomber.name": "Bomber",
  "hero.bomber.description": "Bombs that crush crowds",
  "hero.sparky.name": "Sparky",
  "hero.sparky.description": "Instant sparks for fast zombies",
  "hero.blaze.name": "Blaze",
  "hero.blaze.description": "Close-range fire over an area",
  "hero.frosty.name": "Frosty",
  "hero.frosty.description": "Ice that slows zombies down",
} as const;

type Key = keyof typeof en;

const ru: Record<Key, string> = {
  "win.pay.telegram": "Открыть в Telegram",
  "win.pay.telegramNote": "Пропуск и VIP доступны в Telegram",
  "hero.gunner.name": "Gunner",
  "hero.gunner.description": "Стабильный урон по одной цели",
  "hero.bomber.name": "Bomber",
  "hero.bomber.description": "Бомбы против толпы",
  "hero.sparky.name": "Sparky",
  "hero.sparky.description": "Мгновенная искра по быстрым",
  "hero.blaze.name": "Blaze",
  "hero.blaze.description": "Огонь по площади вблизи",
  "hero.frosty.name": "Frosty",
  "hero.frosty.description": "Лёд замедляет зомби",
};

const uk: Record<Key, string> = {
  "win.pay.telegram": "Відкрити в Telegram",
  "win.pay.telegramNote": "Пропуск і VIP доступні в Telegram",
  "hero.gunner.name": "Gunner",
  "hero.gunner.description": "Стабільна шкода по одній цілі",
  "hero.bomber.name": "Bomber",
  "hero.bomber.description": "Бомби проти натовпу",
  "hero.sparky.name": "Sparky",
  "hero.sparky.description": "Миттєва іскра по швидких",
  "hero.blaze.name": "Blaze",
  "hero.blaze.description": "Вогонь по площі зблизька",
  "hero.frosty.name": "Frosty",
  "hero.frosty.description": "Лід сповільнює зомбі",
};

const features = import.meta.glob<{ messages: MessageBundle<string> }>("./*/messages.ts", { eager: true });

export const windowMessages: MessageBundle<string> = Object.values(features).reduce<MessageBundle<string>>(
  (all, { messages: m }) => ({ en: { ...all.en, ...m.en }, ru: { ...all.ru, ...m.ru }, uk: { ...all.uk, ...m.uk } }),
  { en, ru, uk },
);
